import { Button, FieldText, FlexBox } from '@dixa/lib-shared-habla';
import { useCollectionId } from 'articleEditor/hooks/useCollectionId';
import {
  floatingLinkActions,
  submitFloatingLink,
  useFloatingLinkSelectors,
} from 'lib-knowledge-document-structure';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import { useCallback, useRef } from 'react';

import s from './editLinkTabs.module.scss';
import { HeadingLinkLookup } from './headingLinkLookup';

export const EditElementLinkForm = (): JSX.Element => {
  const collectionId = useCollectionId();
  const isReadOnly = !collectionId;

  const editor = useMyEditorRef();
  const text = useFloatingLinkSelectors().text();
  const linkedElementId = useFloatingLinkSelectors().linkedElementId();

  const setElement = useCallback((newElementId: string) => {
    floatingLinkActions.linkedElementId(newElementId);
  }, []);

  const textRef = useRef<HTMLInputElement>(null);
  const isFormValid = text.length > 0 && !!linkedElementId;

  return (
    <div>
      <HeadingLinkLookup
        onSelect={setElement}
        readOnly={isReadOnly}
        value={linkedElementId}
      />

      <FieldText
        readOnly={isReadOnly}
        label="Text"
        className={s['field']}
        input={{
          value: text,
          name: 'text',
          onChange: (e) => floatingLinkActions.text(e?.target.value || ''),
          // @ts-expect-error Habla's typedefs are wrong, it is an InputElement
          ref: textRef,
        }}
      />

      <FlexBox justifyContent="end" gap="200">
        <Button variant="secondary" onClick={() => floatingLinkActions.hide()}>
          Cancel
        </Button>

        <Button
          disabled={!isFormValid || isReadOnly}
          onClick={() => submitFloatingLink(editor)}
        >
          Save
        </Button>
      </FlexBox>
    </div>
  );
};
